import { red100, grey600 } from 'material-ui/styles/colors'

/** サービス種別 */
export const SERVICE_TYPE = {
  /** 打刻 */
  STAMP: 0,
  /** 明細配信 */
  PAYSLIP: 1,
  /** 勤怠 */
  ATTENDANCE: 6,
}

/** モード */
export const MODE = {
  /** 新しくテナントを作成 */
  CREATE_TENANT: 'CREATE_TENANT',
  /** 既存のテナントに結び付け */
  CONNECT_TENANT: 'CONNECT_TENANT',
}

/** ステップ */
export const STEPS = {
  /** モード選択 */
  MODE_SELECT: 'MODE_SELECT',
  /** ログイン */
  LOGIN: 'LOGIN',
  /** 登録内容の入力 */
  ENTRY_INPUT: 'ENTRY_INPUT',
  /** 入力内容の確認 */
  INPUT_CONFIRM: 'INPUT_CONFIRM',
  /** 認証 */
  AUTHENTICATION: 'AUTHENTICATION',
  /** 契約情報の結び付け */
  CONNECT_TENANT: 'CONNECT_TENANT',
  /** 登録完了 */
  ENTRY_COMPLETE: 'ENTRY_COMPLETE',
}

/**
 * データ長定義
 */
export const lengthInfo = {
  /* 契約ID関連 */
  contract: {
    id: { min: 3, max: 20 },
    mail: { min: 1, max: 256 }
  },
  /* 会社ID関連 */
  company: {
    id: { min: 1, max: 20 },
    name: { min: 0, max: 100 },
    pw: { min: 8, max: 256 }
  },
  /* 管理者ID関連 */
  admin: {
    id: { min: 1, max: 20 },
    name: { min: 0, max: 100 },
    pw: { min: 8, max: Infinity }
  },
  /* 社員ID関連 */
  emproyee: {
    id: { min: 1, max: 16 },
    name: { min: 0, max: 100 },
    pw: { min: 8, max: 256 }
  }
}

export const emproyeePasswordPeriodMax = 999

/**
 * Material-UI の FloatingLabelText の style
 */
export const LabelColor = grey600

/**
 * 入力値が範囲外の場合の背景色
 */
export const InvalidColor = red100

export const API_ERROR_CODE = {
  UPDATED: 1000,
  MAINTENANCE: 2000,
}

/** ローカルストレージキー */
export const LOCAL_STRAGE_KRY = {
  /** UIバージョン管理 */
  UI_VERSION: 'init_ui_version',
}


// WEBPACK FOOTER //
// ./src/define.js